import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    labelOverride?: string;
    extendedStyles?: ProductAddToListLinkStyles;
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
});

const mapDispatchToProps = {
    setAddToListModalIsOpen,
    addToWishList,
};

export interface ProductAddToListLinkStyles {
    link?: LinkPresentationProps;
    button?: ButtonPresentationProps;
}

export const productAddToListLinkStyles: ProductAddToListLinkStyles = {
    button: {
        size: 40,
        buttonType: "outline",
        color: "primary",
        css: css`
            padding: 0;
            border-radius: 2px;
            width: 100%;
            span {
                font-weight: 600;
                &::before {
                    display: inline-block;
                    content: "+";
                    width: 10px;
                    margin: 0 3px;
                }
            }
            &:hover {
                background: ${getColor("common.accent")};
            }
        `,
    },
};

/**
 * @deprecated Use productAddToListLinkStyles instead.
 */
export const productAddToListLink = productAddToListLinkStyles;

const ProductAddToListLink: React.FC<Props> = ({
    productContext: { product, productInfo },
    wishListSettings,
    labelOverride,
    setAddToListModalIsOpen,
    addToWishList,
    extendedStyles,
    ...otherProps
}) => {
    const toasterContext = React.useContext(ToasterContext);
    const [styles] = React.useState(() => mergeToNew(productAddToListLink, extendedStyles));
    if (!product.canAddToWishlist) {
        return null;
    }
    React.useEffect(() => {
        if (window && window.location && window.location.search) {
            const parsedQuery = parseQueryString<{ isReplace: string,criteria:string }>(window.location.search);
            let isLoaded=window.localStorage.getItem(`isLoaded`);
            let temp=true;
            if(isLoaded!=null)
            {
                const arr=JSON.parse(isLoaded);
                if(arr[0]===product.productNumber)
                {
                    temp=false;
                }
                else if(product.canonicalUrl!==window.location.pathname)
                {
                    temp=false;
                }
                else{
                    isLoaded=null;
                    window.localStorage.removeItem(`isLoaded`);
                }
            }
            else if(product.canonicalUrl!==window.location.pathname)
                {
                    temp=false;
                }
            if(parsedQuery.isReplace?.toString()==="1" && isLoaded==null && temp)
            {
                
                toasterContext.addToast({ body: siteMessage("Product_Discontinued",...[parsedQuery.criteria?.toString(),product.manufacturerItem]), messageType: "success",timeoutLength:8000 });
   window.localStorage.setItem(`isLoaded`,JSON.stringify([product.productNumber]));
            }
        }
        else{
            window.localStorage.removeItem(`isLoaded`);
        }
    },[]);

    const addToListLinkClickHandler = () => {
        if (!wishListSettings.allowMultipleWishLists) {
            addToWishList({
                productInfos: [productInfo],
                onSuccess: () => {
                    toasterContext.addToast({ body: siteMessage("Lists_ProductAdded"), messageType: "success" });
                },
                onComplete(resultProps) {
                    if (resultProps.result?.wishList) {
                        // "this" is targeting the object being created, not the parent SFC
                        // eslint-disable-next-line react/no-this-in-sfc
                        this.onSuccess?.(resultProps.result?.wishList);
                    } else if (resultProps.result?.errorMessage) {
                        toasterContext.addToast({ body: resultProps.result?.errorMessage, messageType: "danger" });
                    }
                },
            });
            return;
        }

        setAddToListModalIsOpen({ modalIsOpen: true, productInfos: [productInfo] });
    };
    return (
        <Button
            {...styles.button}
            onClick={addToListLinkClickHandler}
            disabled={productInfo.qtyOrdered <= 0}
            {...otherProps}
        >
            {labelOverride ?? translate("Add to List")}
        </Button>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductAddToListLink));
